module.exports = __webpack_public_path__ + "img/solution-bg.883125aa.png";